import { render, staticRenderFns } from "./StudentMessagesList.vue?vue&type=template&id=532fc1ca"
import script from "./StudentMessagesList.vue?vue&type=script&lang=js"
export * from "./StudentMessagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports